import type { CommissionCalculationWithParts } from '@/services/commissions';
import { formatCurrency } from '@/utils';
import { commissionTotalParts } from './commissionTotalParts';

/**
 * A calculation's Total Commission with the shares that make it up printed
 * underneath (W0-A decision 7), e.g. "Broker ₹76.05 + POSP ₹76.05".
 */
export function CommissionTotalCell({ calc }: { calc: CommissionCalculationWithParts }) {
  const { total, parts, channelOfBroker } = commissionTotalParts(calc);
  return (
    <div>
      <div className="font-bold text-gray-900 dark:text-gray-100">{formatCurrency(total)}</div>
      {parts.length > 0 && (
        <div
          className="mt-0.5 text-xs font-normal text-gray-500 dark:text-gray-400"
          data-testid="total-parts"
        >
          {parts.map((part, i) => (
            <span key={part.key}>
              {i > 0 && ' + '}
              {part.label} {formatCurrency(part.amount)}
            </span>
          ))}
        </div>
      )}
      {channelOfBroker && (
        <div className="text-xs font-normal text-gray-400 dark:text-gray-500">
          Broker share includes {formatCurrency(channelOfBroker.amount)} owed to {channelOfBroker.name}
        </div>
      )}
    </div>
  );
}
